module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fxmDo"))).then(() => parcelRequire('f4eak'));